var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2884 0.683136L23.0209 3.41558C23.8862 4.28086 23.8862 5.64708 23.0209 6.51236L20.4251 9.10818L14.5958 3.27896L17.1917 0.683136C18.0569 -0.182139 19.4232 -0.182139 20.2884 0.683136ZM3.98483 19.7192H6.89944V21.1765H8.35674L7.58255 21.9507C7.49147 22.0418 7.35485 22.1329 7.21822 22.1329L4.12145 22.7704L0.933594 19.5826L1.57116 16.4858C1.57116 16.3492 1.66225 16.2125 1.75333 16.1215L2.52752 15.3473V16.8046H3.98483V19.7192Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7136 13.7984L13.5941 4.91797L19.4233 10.7472L10.5428 19.6276L8.35687 21.8136H6.89956V20.3563H3.98495V17.4417H2.52765V15.9844L4.7136 13.7984ZM1.07034 23.9996C0.614932 23.9996 0.250605 23.5897 0.341687 23.1343L0.933717 20.2197L4.12157 23.4075L1.20696 23.9996H1.07034Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.689eb7217350a896b75214ebb29ce6d0.svg";
export { ForwardRef as ReactComponent };